// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "106c2699231f6508","396": "b44826f822210607","460": "16ede0715f747b3b","917": "f017549294c60f0b","985": "3ac0b4b6ec46d671",}[chunkId] + ".chunk.js"
}